import { gql, useFragment } from "@apollo/client";

// Style
import style from "./reg-agency.module.scss";

// Components
import Image from "next/image";
import Btn from "@/components/btn/btn";
import TermButton from "../term-button/term-button";

const replaceJSX = (str, replacement) => {
  const result = [];
  const keys = Object.keys(replacement);
  const getRegExp = () => {
    const regexp = [];
    keys.forEach((key) => regexp.push(`{${key}}`));
    return new RegExp(regexp.join("|"));
  };

  if (typeof str == "object") {
    result.push(str.slice(0, -1));
    str = str[str.length - 1];
  }

  str.split(getRegExp()).forEach((item, i) => {
    result.push(item, replacement[keys[i]]);
  });
  return result;
};

// function addBtn(label, term) {
//   const btnReplace = term + "{component}";
//   return label.replace(term, btnReplace);
// }

function addBtn(label, term, id) {
  const btnReplace = term + "{component}";
  const labelType = typeof label;
  let newLabel = "";

  if (labelType == "array" || labelType == "object") {
    newLabel = label.reduce((acc, cur) => {
      const type = typeof cur;
      if (type === "undefined") {
        return acc;
      } else if (type === "object") {
        return [acc, cur];
      } else if (cur.includes(term)) {
        return [acc, cur.replace(term, btnReplace)];
      } else {
        return [acc, cur];
      }
    });
  } else if (typeof label == "undefined") {
    return;
  } else {
    newLabel = label.replace(term, btnReplace);
  }

  return replaceJSX(newLabel, {
    component: <TermButton term={term} key={term + "_" + id} />,
    // html: (<span></span>),
    // label: "",
  });
}

// const labelTerms = {
//   1701: { term: "FDA", termID: "" }, // U.S. Food And Drug Administration (FDA)
//   1705: { term: "WHO", termID: "" }, // World Health Organization (WHO)
//   1706: { term: "Health Canada", termID: 2287 }, // Health Canada
//   1707: { term: "EFSA", termID: "" }, // European Food Safety Authority (EFSA)
//   1858: { term: ["FAO", "WHO", "JECFA"], termID: ["", "", ""] }, // Joint FAO/WHO Expert Committee on Food Additives (JECFA)
//   2387: { term: "Codex Alimentarius", termID: 2556 }, // Codex Alimentarius
//   // 2388: { term: "Food and Agriculture", termID: "" }, // Food and Agriculture
//   2389: { term: "European Commission", termID: 2555 }, // European Commission
// };

// Key: Reg Agency databaseID
const labelTerms = {
  1701: "FDA", // U.S. Food And Drug Administration (FDA)
  1705: "WHO", // World Health Organization (WHO)
  1706: "Health Canada", // Health Canada
  1707: "EFSA", // European Food Safety Authority (EFSA)
  1858: ["FAO", "WHO", "JECFA"], // Joint FAO/WHO Expert Committee on Food Additives (JECFA)
  2387: "Codex Alimentarius", // Codex Alimentarius
  // 2388: "Food and Agriculture" , // Food and Agriculture
  2389: "European Commission", // European Commission
};

export default function RegAgency({ regItem, auth }) {
  // Use Fragment
  const { complete, data } = useFragment({
    fragment: RegAgency.fragments.entry,
    fragmentName: "RegAgencyFragment",
    from: regItem,
  });
  if (!complete) {
    return;
  }

  // if (!data.agencyLink && !data.agencyText) {
  //   return null;
  // }

  const agency = data.agency.nodes[0];
  let label = agency.title;
  const img = agency?.featuredImage.node.sourceUrl;
  const fdaLabel = auth?.label;
  const fdaAuth = auth?.authorizations;

  const labelTerm = labelTerms[agency.databaseId];
  if (labelTerm) {
    const labelTermType = typeof labelTerm;
    if (labelTermType == "array" || labelTermType == "object") {
      labelTerm.map((item) => {
        label = addBtn(label, item, agency.databaseId);
      });
    } else {
      label = addBtn(label, labelTerm, agency.databaseId);
    }
  }

  return (
    <div className={style.agencyItem}>
      {img && (
        <div className={style.iconContainer}>
          <Image src={img} alt="" width={135} height={110} />
        </div>
      )}

      <div className={style.agencyContent}>
        <h3>{label}</h3>

        {agency.databaseId === 1701 && (fdaLabel || fdaAuth) && (
          <div className={style.fdaAuth}>
            <p>
              {fdaLabel && <span className={style.fdaLabel}>{fdaLabel} </span>}
              {fdaAuth && (
                <>
                  (
                  {fdaAuth.nodes?.map((term, i, arr) => {
                    return (
                      <span key={i}>
                        {term.title}
                        <TermButton term={term.title} />
                        {arr.length - 1 !== i && <>, </>}
                      </span>
                    );
                  })}
                  )
                </>
              )}
            </p>
          </div>
        )}
        {data.agencyText && (
          <div
            className={style.agencyCopy}
            dangerouslySetInnerHTML={{
              __html: data.agencyText,
            }}
          />
        )}
      </div>
      {data.agencyLink && (
        <Btn
          button={{
            url: data.agencyLink,
            title: "Learn More →",
            target: "_blank",
          }}
        />
      )}
    </div>
  );
}

RegAgency.fragments = {
  entry: gql`
    fragment RegAgencyFragment on IngredientsFieldsRegulatoryAgencies {
      id
      __typename
      agencyLink
      agencyText
      agency {
        nodes {
          ... on RegulatoryAgency {
            id
            databaseId
            title
            featuredImage {
              node {
                sourceUrl
                mediaItemUrl
              }
            }
          }
        }
      }
    }
  `,
};
